import apis from '@/apis';
import { SET_STATE } from './helper';
import { addWatermark, removeWatermark, getFixedFileName } from '@/utils';
import { sendLog, Sentry } from '@/utils/sentry';
import { nextTick } from 'vue';
import { generateUUID } from '@/utils/uuid';

export default {
  namespaced: true,
  state: {
    loading: false,
    requestIds: [],
    msgList: [],
    loadedMsgListRequestIds: [],
    imageList: [], // 从URL直接创建
    // 重做id
    againRequestId: '',
    requestId: new URL(location.href).searchParams.get('RequestId') || '',
    currentIndex: 0,
    editResultMap: {},
    fixType: '',
    textHidden: false,
    // 双列模式新增状态
    sourceImageList: [], // 待选列表（所有图片）
    editImageList: [], // 编辑列表（选中的图片）
    selectedImageIds: [], // 已选中的图片ID集合
  },
  getters: {
    readyImageList(state) {
      return state.imageList.filter(i => i.requestId);
    },
  },
  mutations: {
    SET_STATE,
    SET_IMAGE_LIST(state, imageInfoMap) {
      state.imageList = state.requestIds
        .filter(id => imageInfoMap[id]?.OriginUrl)
        .map(id => {
          return { ...imageInfoMap[id], requestId: id };
        });
    },
    SET_IMAGE_LIST_WITH_DATAURI(state, imageInfoMap) {
      console.log({ imageInfoMap });
      state.imageList = state.msgList.map(msg => {
        const { url, requestId } = msg;
        if (requestId) {
          return { ...imageInfoMap[requestId], requestId };
        } else {
          return { OriginUrl: url };
        }
      });
    },
    SET_EDIT_RESULT_MAP(state, map) {
      Object.assign(state.editResultMap, map);
    },
    SET_HIDE_TEXT: (state, hide) => {
      state.textHidden = hide;
    },
    // 从URLs直接创建图片列表（最小化改动方案）
    SET_IMAGE_LIST_FROM_URLS(state, urls) {
      // 从URLs直接创建图片对象
      state.imageList = urls.map((url, index) => ({
        requestId: generateUUID(), // 生成标准UUID
        OriginUrl: url,
        SslUrl: url,
        Url: url,
        name: `图片${index + 1}`,
        // 其他必要字段设为默认值
        HasWatermark: false,
        WatermarkLayerUrl: '',
        WatermarkLayerSslUrl: '',
      }));

      // 设置requestIds为生成的ID数组
      state.requestIds = state.imageList.map(img => img.requestId);
    },
    // 双列模式新增 mutations
    INIT_SOURCE_LIST(state, imageList) {
      state.sourceImageList = imageList;
      // 自动将第一张添加到编辑列表
      if (imageList.length > 0 && state.editImageList.length === 0) {
        const firstImage = imageList[0];
        state.editImageList = [firstImage];
        state.selectedImageIds = [firstImage.requestId];
      }
    },
    ADD_TO_EDIT_LIST(state, image) {
      if (!state.selectedImageIds.includes(image.requestId)) {
        state.editImageList.push(image);
        state.selectedImageIds.push(image.requestId);
      }
    },
    REMOVE_FROM_EDIT_LIST(state, requestId) {
      state.editImageList = state.editImageList.filter(img => img.requestId !== requestId);
      state.selectedImageIds = state.selectedImageIds.filter(id => id !== requestId);
    },
    REORDER_EDIT_LIST(state, newOrder) {
      // 创建新数组确保 Vue 响应式更新
      state.editImageList = [...newOrder];
    },
    // 插入空白图片到指定位置
    INSERT_BLANK_IMAGE(state, { blankImage, index }) {
      // 在指定位置插入空白图片
      state.editImageList.splice(index, 0, blankImage);
      state.selectedImageIds.push(blankImage.requestId);
    },
  },
  actions: {
    setFixType({ commit }, fixType) {
      commit('SET_STATE', { fixType });
    },
    saveSingleImage: ({ commit, state, rootState }, paylpad) => {
      const { requestId, textHidden } = state;
      if (!$XJCanvas || !requestId) return Promise.reject();
      const {
        WatermarkLayerUrl,
        HasWatermark,
        OriginUrlRemote,
        editorSize,
        cropInfo,
        imageExtenssion,
        imageQuality,
        returnBase64,
      } = rootState.app;
      return new Promise((resolve, reject) => {
        if (textHidden) {
          commit('SET_HIDE_TEXT', false);
        }
        nextTick(() => {
          addWatermark(WatermarkLayerUrl, HasWatermark, () => {
            try {
              const { canvasWidth, canvasHeight } = editorSize;
              const { left = 0, top = 0, width = canvasWidth, height = canvasHeight } = cropInfo;
              const base64 = $XJCanvas.toDataURL({
                format: imageExtenssion,
                multiplier: 1,
                quality: imageQuality,
                left,
                top,
                width,
                height,
              });
              commit('SET_EDIT_RESULT_MAP', {
                [requestId]: {
                  ...state.editResultMap[requestId],
                  ...(returnBase64 ? { base64 } : {}),
                  isLocalSave: true, // 标记为本地保存
                },
              });
              resolve(base64);
              // sendLog(`saveAll_upload:success`);
              removeWatermark();
              // apis.app
              //   .uploadImage({
              //     filename: getFixedFileName(OriginUrlRemote, false),
              //     base64,
              //     requestId,
              //   })
              //   .then(res => {
              //     const url = res.sslUrl || res.url;
              //     commit('SET_EDIT_RESULT_MAP', {
              //       [requestId]: {
              //         ...state.editResultMap[requestId],
              //         url,
              //         ...(returnBase64 ? { base64 } : {}),
              //       },
              //     });
              //     resolve(url);
              //     // sendLog(`saveAll_upload:success`);
              //     removeWatermark();
              //   })
              //   .catch(() => {
              //     reject();
              //     removeWatermark();
              //     sendLog(`saveAll_upload:error`);
              //   })
              //   .finally(() => {
              //     if (textHidden) commit('SET_HIDE_TEXT', true);
              //   });
            } catch (err) {
              sendLog(`canvas2dataUrl_error:${err.message}`);
              reject();
              if (textHidden) commit('SET_HIDE_TEXT', true);
            }
          });
        });
      });
    },
    setRequestIds({ commit }, ids) {
      const requestId = ids[0];
      commit('SET_STATE', {
        requestIds: ids,
        requestId,
      });
      Sentry.setTag('requestId', requestId);
    },
    setRequestIdsOrUrl({ commit }, payload) {
      const { imageList: msgList } = payload;
      console.log('setRequestIdsOrUrl', payload);
      const requestId = payload.requestId || (msgList.filter(i => i.requestId)[0] || {}).requestId;
      const result = {
        msgList,
      };
      if (requestId) {
        result.requestId = requestId;
      }
      commit('SET_STATE', result);
    },
    getImageList({ commit, state }, ids) {
      if (ids.length === 0) {
        if (state.fixType === 'requestIdsOrUrl') {
          commit('SET_IMAGE_LIST_WITH_DATAURI', {});
        }
        return;
      }
      commit('SET_STATE', { loading: true });
      apis.app
        .getImageList(ids)
        .then(res => {
          if (state.fixType === 'requestIdsOrUrl') {
            commit('SET_IMAGE_LIST_WITH_DATAURI', res);
            commit('SET_STATE', { loadedMsgListRequestIds: [...state.loadedMsgListRequestIds, ...ids.split(',')] });
          } else {
            commit('SET_IMAGE_LIST', res);
          }
          // 初始map
          const initialMap = state.imageList.reduce((map, item) => {
            map[item.requestId] = { apiTranslateUrl: item.SslUrl || item.Url, url: '' };
            return map;
          }, {});
          commit('SET_EDIT_RESULT_MAP', initialMap);
          // 初始化双列列表
          commit('INIT_SOURCE_LIST', state.imageList);
          commit('SET_STATE', {
            loading: false,
          });
        })
        .catch(() => {
          commit('SET_STATE', { loading: false });
        });
    },
    // 双列模式新增 actions
    addToEditList({ commit, state }, image) {
      if (!state.selectedImageIds.includes(image.requestId)) {
        commit('ADD_TO_EDIT_LIST', image);
        // 如果是第一张添加的图片，自动切换到该图片
        if (state.editImageList.length === 1) {
          commit('SET_STATE', { requestId: image.requestId });
        }
      }
    },
    removeFromEditList({ commit, state, dispatch }, requestId) {
      const isCurrentEditing = state.requestId === requestId;

      if (isCurrentEditing) {
        if (state.editImageList.length > 1) {
          // 如果移除的是当前编辑的图片，且还有其他图片，切换到下一张
          const currentIndex = state.editImageList.findIndex(img => img.requestId === requestId);
          const nextImage = state.editImageList[currentIndex + 1] || state.editImageList[currentIndex - 1];

          if (nextImage) {
            commit('SET_STATE', { requestId: nextImage.requestId });
          }
        } else {
          // 删除最后一张图片，清空 Canvas 和状态
          commit('SET_STATE', { requestId: '' });

          // 清空 Canvas
          if (window.$XJCanvas) {
            window.$XJCanvas.clear();
            window.$XJCanvas.setBackgroundImage(null);
            window.$XJCanvas.renderAll();
            window.$XJCanvas.dispose();
            window.$XJCanvas = null;
          }

          // 重置编辑器状态（包括原图）
          commit(
            'app/SET_STATE',
            {
              objectPropsMap: {},
              objectUIDs: [],
              selectedObjectUid: -1,
              loadDataError: false,
              editorLoading: false,
              imageExtension: state.originalImageExtension,
              originalImage: null,
            },
            { root: true }
          );
        }
      }

      commit('REMOVE_FROM_EDIT_LIST', requestId);
    },
    // 插入空白图片
    insertBlankImage({ commit, state }, { blankImage, index }) {
      commit('INSERT_BLANK_IMAGE', { blankImage, index });

      // 插入后是第一个图片，则激活它
      if (state.editImageList.length === 1 || index === 0) {
        commit('SET_STATE', { requestId: blankImage.requestId });
      }

      // 添加到编辑结果映射
      commit('SET_EDIT_RESULT_MAP', {
        [blankImage.requestId]: {
          apiTranslateUrl: blankImage.OriginUrl,
          url: '',
        },
      });
    },

    // 从URLs初始化图片列表
    // src/store/multi.js - replace initWithUrls with this
    async initWithUrls({ commit, state, dispatch }, urls) {
      // debugger;
      if (!urls || urls.length === 0) {
        console.warn('initWithUrls: URLs数组为空');
        return;
      }

      console.log('使用URLs初始化图片列表:', urls);

      try {
        commit('SET_STATE', { loading: true });

        // 直接从URLs创建图片对象（跳过API调用）
        commit('SET_IMAGE_LIST_FROM_URLS', urls);

        // 初始化编辑结果映射
        const initialMap = state.imageList.reduce((map, item) => {
          map[item.requestId] = {
            apiTranslateUrl: item.SslUrl || item.Url,
            url: '',
          };
          return map;
        }, {});
        console.log({ initialMap });
        commit('SET_EDIT_RESULT_MAP', initialMap);

        // 初始化双列列表（复用现有逻辑）
        commit('INIT_SOURCE_LIST', state.imageList);

        // ---- 新增：激活第一张图片，使 ImageEditor 开始初始化 ----
        if (state.imageList && state.imageList.length > 0) {
          const firstId = state.imageList[0].requestId;
          // 设置 multi 的 requestId 与当前索引（触发 ImageEditor 的 watcher）
          commit('SET_STATE', { requestId: firstId, currentIndex: 0, initFromUrls: true });
          // 关闭绘图模式（和之前切图逻辑一致）
          // commit('app/SET_DRAWING_MODE', false, { root: true });
        }
        // -------------------------------------------------------

        commit('SET_STATE', { loading: false });

        console.log('URLs初始化完成，图片数量:', urls.length);
      } catch (error) {
        console.error('URLs初始化失败:', error);
        commit('SET_STATE', { loading: false });
        throw error;
      } finally {
        console.log({ 'initial--after---state': state });
      }
    },
  },
};
